<template src="./component.html"></template>

<script>
export default {
  name: "Possibility",
  data() {
    return {
      navigator: 1,
      mbMall: false,
      mbMallCategory: 1,
      mbFranchise: false,
      mbFranchiseCategory: 1,
      mbFoodCourts: false,
      mbFoodCourtsCategory: 1,
    }
  },
  methods: {
    onNavigator(item) {
      this.navigator = item;
    },
    onCategory(item, value) {
      switch (item) {
        case 'mall':
          this.mbMallCategory = value;
          break;
        case 'franchise':
          this.mbFranchiseCategory = value;
          break;
        case 'foodCourts':
          this.mbFoodCourtsCategory = value;
          break;
      }
    }
  }
}
</script>

<style src="./component.scss" scoped lang="scss"/>
